const publicRoutes = [
  {
    path: '/verifikacija-registracije',
    name: 'verifyRegistration',
    public: true
  },
  {
    path: '/istekao-verifikacioni-link',
    name: 'registrationTokenExpired',
    public: true
  },
  {
    path: '/prijava',
    name: 'login',
    public: true
  },
  {
    path: '/kreiraj-nalog',
    name: 'createAccount',
    public: true
  },
  {
    path: '/registracija-verifikacija-email',
    name: 'emailVerification',
    public: true
  },
  {
    path: '/registracija',
    name: 'registration',
    public: true
  },
  {
    path: '/registracija-email-potvrda',
    name: 'thankYouPage',
    public: true
  },
  {
    path: '/zaboravljena-lozinka',
    name: 'forgottenPassword',
    public: true
  },
  {
    path: '/lozinka-potvrda',
    name: 'forgottenPasswordConfirmation',
    public: true
  },
  {
    path: '/kreiraj-lozinku',
    name: 'createPassword',
    public: true
  },
  {
    path: '/reset-lozinke-istekao-link',
    name: 'resetPasswordExpiredLink',
    public: true
  },
  {
    path: '/uspesno-resetovana-lozinka',
    name: 'resetPasswordConfirmation',
    public: true
  },
  {
    path: '/placanje/uspjesno',
    name: 'paymentSuccess',
    public: true
  },
  {
    path: '/placanje/neuspjesno',
    name: 'paymentFail',
    public: true
  },
  {
    path: '/verifikacija-promene-emaila',
    name: 'emailChangeVerification',
    public: true
  }

]

export default publicRoutes
